module.exports = __webpack_public_path__ + "img/Check.3019fb4e.svg";